import type { ApiModels } from '@ori/global-api-client';
import useSWR from 'swr';

import { useConfiguration } from '~/shared/contexts/configurationContext';
import type { ApiError } from '~/shared/models/ApiError';
import type { FetcherOptions } from '~/shared/types/FetcherOptions';
import { getSafeUrl } from '~/shared/utils/getSafeUrl';

export function useCustomerProfile() {
  const { customerId, tenant, globalApiUrl } = useConfiguration();

  const url = getSafeUrl(`/customers/${customerId}/profile`, globalApiUrl);
  const options: FetcherOptions = {
    tenant,
  };

  return useSWR<ApiModels.GlobalCustomersProfileDto, ApiError>([url, options]);
}
